import "C:\\project\\\u6587\u5316\u5BAB\\code\\whg\\Web\\Web\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "C:\\project\\\u6587\u5316\u5BAB\\code\\whg\\Web\\Web\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.js";
import "C:\\project\\\u6587\u5316\u5BAB\\code\\whg\\Web\\Web\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.object.assign.js";
import "C:\\project\\\u6587\u5316\u5BAB\\code\\whg\\Web\\Web\\node_modules\\@vue\\babel-preset-app\\node_modules\\core-js\\modules\\es.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css'; // 加载自定义样式，如果需要变更，则修改下面地址就行。配置文件根据颜色放在theme文件夹中
// 多入口修改：此处需要注意因为目录变化导致的相对地址变化，要记得及时更改，否则会引用报错

import '../../../theme/green/index.css';
import locale from 'element-ui/lib/locale/lang/en'; // lang i18n

import '@/styles/index.scss'; // global css

import '@/styles/pms.scss'; // pms css

import '@/styles/otherSystem.scss'; // pms css

import App from './App';
import store from '../../store';
import router from '../../router/SLXC';
import '@/icons'; // icon

import './permission'; // permission control

import _i18n from '../../lang'; // Internationalization

import tool from '../../utils/tool';
import cloneDeep from 'lodash/cloneDeep';
import '@/element-ui';
import formCreate from 'form-create/element';
import Print from '@/utils/print'; // 打印

import { registerMicroApps, start } from 'qiankun'; // 保存整站vuex本地储存初始状态

window.SITE_CONFIG = {};
window.SITE_CONFIG['storeState'] = cloneDeep(store.state);
Vue.use(formCreate);
Vue.use(Print);
registerMicroApps([{
  name: 'test',
  // app name registered
  entry: '//192.168.4.213:11170',
  container: '#qiankunBox',
  activeRule: '/system/menu'
}, {
  name: 'vue app',
  entry: {
    scripts: ['//localhost:7100/main.js']
  },
  container: '#yourContainer2',
  activeRule: '/yourActiveRule2'
}]);
start();
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mockXHR()
// }

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium',
  // set element-ui default size
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
}); // set ElementUI lang to EN

Vue.use(ElementUI, {
  locale: locale
});
Vue.use(tool);
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  }
});